class GrowEmailPopup extends HTMLElement {
  connectedCallback() {
    this.dialogComponent = this.querySelector('dialog-component');
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('.grow-email-popup__form');
    this.closeButtons = this.querySelectorAll('[data-popup-close]');
    this.isDesignMode = this.dataset.designMode === 'true';
    this.delayMs = Number(this.dataset.delaySeconds || 4) * 1000;
    this.dismissDays = Number(this.dataset.dismissDays || 14);
    this.storageKey = this.dataset.storageKey || 'grow-email-popup-dismissed';
    this.formState = this.form?.querySelector('[data-popup-form-state]')?.dataset.popupFormState || 'idle';

    this.closeButtons.forEach((button) => button.addEventListener('click', this.#handleManualClose));
    this.dialogComponent?.addEventListener('dialog:close', this.#handleDialogClose);

    if (!this.#isEnabled()) return;

    if (this.isDesignMode) return;

    if (this.formState === 'success' || this.formState === 'error') {
      requestAnimationFrame(() => this.#show());
      return;
    }

    if (this.#isDismissed()) return;

    this.openTimeout = window.setTimeout(() => this.#show(), this.delayMs);
  }

  showPopup() {
    if (!this.#isEnabled()) return false;

    if (this.openTimeout) {
      window.clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }

    this.#show();
    return true;
  }

  disconnectedCallback() {
    if (this.openTimeout) {
      window.clearTimeout(this.openTimeout);
    }

    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.#handleManualClose));
    this.dialogComponent?.removeEventListener('dialog:close', this.#handleDialogClose);
  }

  #isEnabled() {
    return this.dataset.enabled === 'true';
  }

  #show() {
    if (this.dialog?.open) return;
    this.dialogComponent?.showDialog();
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.querySelector('.grow-email-popup__input')?.focus();
      });
    });
  }

  #handleManualClose = () => {
    this.#persistDismissal();
    this.dialogComponent?.closeDialog();
  };

  #handleDialogClose = () => {
    this.#persistDismissal();
  };

  #isDismissed() {
    try {
      const storedValue = window.localStorage.getItem(this.storageKey);
      if (!storedValue) return false;

      const expiresAt = Number(storedValue);
      if (!expiresAt || Number.isNaN(expiresAt)) {
        window.localStorage.removeItem(this.storageKey);
        return false;
      }

      if (Date.now() > expiresAt) {
        window.localStorage.removeItem(this.storageKey);
        return false;
      }

      return true;
    } catch {
      return false;
    }
  }

  #persistDismissal() {
    if (this.isDesignMode) return;

    try {
      const expiresAt = Date.now() + this.dismissDays * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(this.storageKey, String(expiresAt));
    } catch {
      // Ignore storage failures and fall back to showing the popup again next visit.
    }
  }
}

if (!customElements.get('grow-email-popup')) {
  customElements.define('grow-email-popup', GrowEmailPopup);
}
